import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { NotificationContextProvider } from "context/NotificationContext"
import { LanguageContextProvider } from "context/LanguageContext";
import { CookieConsentContextProvider } from 'context/CookieConsentContext';
import { checkContrastAtStart } from 'extra/theme';
import { backToTopSmooth } from 'extra/functions';
import Routes from 'routes/Routes';

import Header from 'components/main/Header';
import CookieConfirm from 'components/general/CookieConfirm';

import "styles/main/main.scss";
import "styles/main/contrast.scss";

export default function App() {

	const location = useLocation();

	useEffect(() => checkContrastAtStart(), []);

	useEffect(() => backToTopSmooth(), [ location ]);

	return (
		<NotificationContextProvider>
			<LanguageContextProvider>
				<CookieConsentContextProvider>

					<CookieConfirm/>

					<Header/>
					<Routes/>

				</CookieConsentContextProvider>
			</LanguageContextProvider>
		</NotificationContextProvider>
	)
}
